import { IReview } from '@/models/review.model';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Rate from 'src/shared/ui/Rate/Rate';
import { renderDate } from 'src/shared/utils/dataRender';
import { ReviewDetailsBlock, SubRateContainer, SubRateOuter } from '../ReviewDetailsBlock';
import { StyledComment } from './ReviewDetailsStyles';
import { getProductUrl } from '../../utils';

interface ReviewDetailsProps {
  review: IReview | null;
}

export const ReviewDetails: FC<ReviewDetailsProps> = ({ review }) => {
  const { t } = useTranslation(['common']);
  if (!review) {
    return null;
  }

  const productUrl = getProductUrl(review.channel.siteUrl, review.product.urlPath ?? review.productId);

  return (
    <>
      <ReviewDetailsBlock title={t('title_user_name')}>
        <p>{review.userName}</p>
      </ReviewDetailsBlock>
      <ReviewDetailsBlock title={t('title_date_and_time')}>
        <p>{renderDate(review.createdAt, 'D MMM, hh:mm a')}</p>
      </ReviewDetailsBlock>
      <ReviewDetailsBlock title={t('title_product_link')}>
        <a href={productUrl} target="_blank" rel="noreferrer">
          {productUrl}
        </a>
      </ReviewDetailsBlock>
      <ReviewDetailsBlock title={t('title_product_id')}>
        <p>{review.productId}</p>
      </ReviewDetailsBlock>
      <ReviewDetailsBlock title={t('title_comment')}>
        <StyledComment>{review.reviewText}</StyledComment>
      </ReviewDetailsBlock>
      <ReviewDetailsBlock title={t('title_overall_rating')}>
        <Rate disabled value={review.overallRating || 0} />
      </ReviewDetailsBlock>
      <ReviewDetailsBlock title={t('title_rating_by_parameter')}>
        <SubRateOuter>
          <SubRateContainer>
            <p>{t('text_easy_to_use')}:</p>
            <Rate disabled value={review.easeOfUseRating || 0} />
          </SubRateContainer>
          <SubRateContainer>
            <p>{t('text_durability')}:</p>
            <Rate disabled value={review.durabilityRating || 0} />
          </SubRateContainer>
          <SubRateContainer>
            <p>{t('text_value_for_money')}:</p>
            <Rate disabled value={review.valueForMoneyRating || 0} />
          </SubRateContainer>
        </SubRateOuter>
      </ReviewDetailsBlock>
    </>
  );
};
